import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { FormField } from '../form-field';
import { FormFieldConfig } from '../dropdown/form_field_config';
import { UserService } from 'src/app/admin/core/services/user.service';
import { Language } from 'src/app/shared/entities/language';
import { environment } from 'src/environments/environment';
import { CustomTranslateService } from 'src/app/shared/services/custom-translate.service';

@Component({
    selector: 'app-textbox',
    templateUrl: './textbox.component.html',
    styleUrls: ['./textbox.component.css'],
})
export class TextboxComponent implements OnInit {
    @Input() config: FormFieldConfig;
    @Input() data: any;

    editMode: boolean = false;
    value: any;
    typeName: any;
    multilangueMap: { [key: string]: any } = {};
    languages: Language[] = [];

    constructor(
        public userService: UserService,
        private customTranslateService: CustomTranslateService
    ) {}

    ngOnInit(): void {
        this.setVisibility();
        this.languages = environment.languages.map((lang) => {
            return {
                key: lang.locale,
                label: lang.text,
                selected: this.customTranslateService.currentLang === lang.code,
            };
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['config']) {
            this.config = changes['config'].currentValue;
            this.value = this.config.value;
            this.editMode = this.config.editMode;
            this.typeName = this.config.typeName;
            if (this.config.value) {
                this.multilangueMap = this.config.value;
            }
        }
    }

    setVisibility() {
        if (!this.config.isDynamic) {
            this.config.isVisible = true;
            this.config.isModifiable = true;
        }
    }

    isLocal(local: string): boolean {
        return this.languages?.find((l) => l.key === local && l.selected) !== undefined;
    }

    get isColorHexa(): boolean {
        return this.config.name === 'valeurHexa';
    }

    typeOf(value: any): string {
        return typeof value;
    }
}
